import classNames from 'classnames';
import React from 'react';
import styles from './checkbox.css';
import { IconCheck } from './icons';
import { TextRegularLight, TextSmallLight } from './typography';

export function Checkbox({
  value,
  disabled,
  onChange,
  label,
  size = 'medium',
  labelColor = 'grey',
  type = 'checkbox',
}: {
  id?: string;
  value: boolean;
  disabled?: boolean;
  onChange?(newValue: boolean): void;
  label: string;
  size?: 'medium' | 'large';
  labelColor?: 'grey' | 'black' | 'inherit';
  type?: 'checkbox' | 'radio';
}) {
  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange?.(e.target.checked);
    },
    [onChange],
  );

  const id = React.useId();
  const Text = size === 'medium' ? TextSmallLight : TextRegularLight;

  return (
    <label
      className={classNames(styles.checkboxContainer, label && styles.hasLabel)}
      htmlFor={id}
    >
      <input
        id={id}
        type={type}
        className={classNames(
          styles.checkbox,
          type === 'radio' && styles.isRadio,
        )}
        checked={value}
        onChange={handleChange}
        disabled={disabled}
      />
      <div
        className={classNames(styles.icon, type === 'radio' && styles.isRadio)}
      >
        {type === 'checkbox' && <IconCheck />}
      </div>
      {label && (
        <span className={styles.checkboxLabel}>
          <Text color={labelColor} tag="span">
            {label}
          </Text>
        </span>
      )}
    </label>
  );
}
